module.exports = __webpack_public_path__ + "static/media/after.e1a9268c.svg";